import React, { useState, Suspense } from "react";
import Header from "../../Components/Header";
import ServiceCard from "../../Components/ServiceCard";
import Modal from "../../Components/Modal";
import TransferFromWalletToWallet from "../Wallet/TransferFromWalletToWallet";
import { mtnServices, syriatelServices } from "../../Data/servicesData";
import Loading from "../../Components/Loading";

import { useWallet } from "../../Context/WalletContext";

import useAbiliBalance from "../../Hooks/Services/useAbiliBalance";

const Services = () => {
  const { balance, isLoading, error } = useWallet();

  const {
    balance: abiliBalance,
    isLoading: abiliLoading,
    error: abiliError,
  } = useAbiliBalance();


  const [activeService, setActiveService] = useState(null);
  const [walletModalOpen, setWalletModalOpen] = useState(false);

  // دالة لتنسيق الأرقام بالفواصل
  const formatNumberWithCommas = (num) => {
    if (!num && num !== 0) return "—";
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <section className="bg-light min-h-screen font-cairo">
      <Header
        title="خدماتنا"
        balance={
          isLoading
            ? "جاري التحميل..."
            : error
              ? "حدث خطأ أثناء جلب الرصيد"
              : `${balance ?? "—"} ليرة سورية`
        }
        rightContent={
          <div className="flex items-center gap-3">
            {/* Abili Balance */}
            <div className="px-4 py-1.5 rounded-full bg-light text-main2 text-md font-bold">
              <span className="text-main1 text-md font-bold">Abili: </span>
              {abiliLoading
                ? "جاري التحميل..."
                : abiliError
                  ? "خطأ في جلب رصيد Abili"
                  : `${formatNumberWithCommas(abiliBalance)} ليرة سورية`}
            </div>

            {/* تحويل رصيد */}
            <button
              onClick={() => setWalletModalOpen(true)}
              className="px-4 py-1.5 rounded-full bg-light text-main1 text-md font-medium hover:bg-opacity-90 transition"
            >
              تحويل رصيد محفظة
            </button>
          </div>
        }
      />

      <div className="max-w-7xl mx-auto px-4 py-8 space-y-12">
        {/* MTN */}
        <div>
          <h6 className="flex items-center text-xl font-bold text-main2 mb-6">
            <span className="flex-1 h-0.5 bg-dark/20 mx-4"></span>
            <span className="px-4 whitespace-nowrap">خدمات MTN</span>
            <span className="flex-1 h-0.5 bg-dark/20 mx-4"></span>
          </h6>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {mtnServices.map((service, index) => (
              <ServiceCard
                key={index}
                title={service.title}
                description={service.description}
                buttonText={service.buttonText}
                onClick={() => setActiveService(service)}
                delay={index * 0.1}
              />
            ))}
          </div>
        </div>

        {/* Syriatel */}
        <div>
          <h6 className="flex items-center text-xl font-bold text-main2 mb-6">
            <span className="flex-1 h-0.5 bg-dark/20 mx-4"></span>
            <span className="px-4 whitespace-nowrap">خدمات Syriatel</span>
            <span className="flex-1 h-0.5 bg-dark/20 mx-4"></span>
          </h6>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {syriatelServices.map((service, index) => (
              <ServiceCard
                key={index}
                title={service.title}
                description={service.description}
                buttonText={service.buttonText}
                onClick={() => setActiveService(service)}
                delay={index * 0.1}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Wallet Transfer Modal */}
      <Modal
        isOpen={walletModalOpen}
        onClose={() => setWalletModalOpen(false)}
        title="تحويل رصيد محفظة"
        size="md"
      >
        <TransferFromWalletToWallet />
      </Modal>

      {/* Modal for MTN/Syriatel only */}
      <Modal
        isOpen={!!activeService}
        onClose={() => setActiveService(null)}
        title={activeService?.title || ""}
        size="md"
      >
        {activeService?.component ? (
          <Suspense
            fallback={
              <div className="p-6 flex justify-center">
                <Loading type="ring" size="lg" color="main1" />
              </div>
            }
          >
            <activeService.component />
          </Suspense>
        ) : (
          <p>{activeService?.description}</p>
        )}
      </Modal>
    </section>
  );
};

export default Services;
